<ng-container *ngIf="(content | translate) && !isNotFound; ">

    <section id="legal-screen" [innerHTML]="content | translate">
    </section>
</ng-container>
<ng-container *ngIf="isNotFound">
    <app-no-route></app-no-route>
</ng-container>